// src/components/Testimonials.jsx
import React from 'react';

const Testimonials = () => (
    <section id="testimonials" className="testimonials">
        <div className="container">
            <h2 className="section-title">What Dreamers Are Saying</h2>
            <div className="testimonials-grid">
                <div className="testimonial-card">
                    <div className="stars">★★★★★</div>
                    <p>"Zenzzz changed my nights! Finally sleeping like a baby."</p>
                    <span className="author">- Sarah K., Verified Buyer</span>
                </div>
                <div className="testimonial-card">
                    <div className="stars">★★★★★</div>
                    <p>"Best sleep aid ever. Natural and effective – highly recommend!"</p>
                    <span className="author">- Mike T., Verified Buyer</span>
                </div>
            </div>
        </div>
    </section>
);

export default Testimonials;